const NavDataLinks = [
	// { id: 1, link: "/", title: "Home" },
	// { id: 2, link: "/About", title: "About" },
	// { id: 3, link: "/services", title: "Services" },
	// { id: 4, link: "/portfolio", title: "Portfolio" },
	// { id: 5, link: "/Contact", title: "Contact" },
	{ id: 1, link: "#header", title: "Home" },
	{ id: 5, link: "#contact-id-routing", title: "Contact" },
	{ id: 2, link: "#about-id-routing", title: "About" },
	{ id: 4, link: "#portfolio-id-routing", title: "Portfolio" },
	{ id: 3, link: "#services-id-routing", title: "Services" },
];

export default NavDataLinks;
